import { InfoCircle } from '@untitled-ui/icons-react';
import { identity } from 'lodash';
import React, { useMemo } from 'react';

import { Callout } from '@myhealth-raccoon/components';

import { AppointmentType } from 'src/services/availability';
import { SentenceList } from 'src/utils/sentenceList';

type Props = {
    appointmentType: AppointmentType;
    className?: string;
};

function ageRange(min: string | null, max: string | null) {
    // max age number in Automed
    if (Number(max) >= 120) {
        max = null;
    }
    if (Number(min) <= 0) {
        min = null;
    }
    if (min && max) {
        return `between ${min} and ${max}`;
    }
    if (min) {
        return `at least ${min}`;
    }
    if (max) {
        return `less ${max}`;
    }
}

export const AppointmentTypeEligibilityTerms = ({ appointmentType, className }: Props) => {
    const selectedAppointmentTypeEligibilityTerms = useMemo(() => {
        const terms = [] as string[];
        if (appointmentType) {
            if (appointmentType.lastF2FVisitInMonths) {
                terms.push(
                    `must have had a face-to-face visit at this clinic within the last ${appointmentType.lastF2FVisitInMonths} months`
                );
            }

            const apptAgeRange = [
                ageRange(appointmentType.lowAgeMin, appointmentType.lowAgeMax),
                ageRange(appointmentType.upperAgeMin, appointmentType.upperAgeMax),
            ]
                .filter(identity)
                .join(', or ');

            if (apptAgeRange) {
                terms.push(`must be ${apptAgeRange} years old`);
            }
        }

        if (terms.length === 0) {
            return null;
        }

        return (
            <>
                <strong className="font-semibold">Eligibility:</strong> You {SentenceList(terms)}.
            </>
        );
    }, [appointmentType]);

    if (!selectedAppointmentTypeEligibilityTerms) {
        return null;
    }

    return (
        <Callout Icon={InfoCircle} color="gray" className={className}>
            {selectedAppointmentTypeEligibilityTerms}
        </Callout>
    );
};
